var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSimpleWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.8 21.7",
    style: {
      enableBackground: "new 0 0 32.8 21.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2,4.4c1.2,0,2.2-1,2.2-2.2S21.4,0,20.2,0S18,1,18,2.2S19,4.4,20.2,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5,4.4c1.2,0,2.2-1,2.2-2.2S13.7,0,12.5,0s-2.2,1-2.2,2.2S11.3,4.4,12.5,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,10.2c2.9,2.4,6.5,3.7,10.3,3.7s7.4-1.3,10.3-3.8c0.7-0.6,0.8-1.8,0.2-2.5c-0.6-0.8-1.8-0.8-2.5-0.2 c-2.2,1.9-5.1,2.9-8,2.9s-5.8-1-8-2.9C7.5,6.8,6.4,6.9,5.8,7.6C5.2,8.5,5.3,9.6,6,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.3,21.7c6,0,11.7-2.3,15.9-6.6c0.7-0.7,0.7-1.8,0-2.5s-1.8-0.7-2.5,0c-3.6,3.6-8.3,5.5-13.4,5.5 c-5,0-9.7-1.9-13.3-5.4c-0.7-0.7-1.8-0.7-2.5,0s-0.7,1.8,0,2.5C4.8,19.4,10.4,21.7,16.3,21.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSimpleWhite);
export default __webpack_public_path__ + "static/media/logo-simple-white.92457f2d1df3cd81dcdd57cb940cb2e6.svg";
export { ForwardRef as ReactComponent };